import { render } from "./PublicCalendarListItem.vue?vue&type=template&id=04e7b4a0"
import script from "./PublicCalendarListItem.vue?vue&type=script&lang=js"
export * from "./PublicCalendarListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__